import { formatPhoneNumber } from 'react-phone-number-input'

export const parseUrl = (url: string): URL | null => {
  if (!url) return null
  try {
    const validUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`
    return new URL(validUrl)
  } catch {
    return null
  }
}

export const parseErrorMessage = (error: unknown, defaultError = `Something went wrong`): string => {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  if (typeof error === 'number') return `An error occurred with code: ${error}`
  return JSON.stringify(error) || defaultError
}

export const intlToLocalNumberV2 = (intlNumber: string, leadingZero = true) => {
  const formatted = formatPhoneNumber(intlNumber)
    .replace(/[^0-9]/g, '')
    .replace(/^0+/, '')
  return leadingZero && formatted ? `0${formatted}` : formatted
}

export const getLeadId = (url?: string): string | null => {
  // If no URL provided, use current window location
  const path = url || window.location.pathname
  // Match pattern /lead/{leadId}
  const match = path.match(/\/lead\/([^/]+)/)
  return match ? match[1] : null
}
